import {createAction, createAsyncThunk, createSelector, createSlice} from '@reduxjs/toolkit';
import api from './api';
import { getParamsFromUrl, isEntryFlow } from './utilities/urlResolver';

export const sendSearchStatistic = createAsyncThunk(
  'sendSearchStatistic',
  async (params) => api.sendSearchStatistic(params)
);

const initialState = {
  showResults: (Object.keys(getParamsFromUrl()).length > 1 && !isEntryFlow() && !isEntryFlow('link-presets-welcome')),
  priceGraphTop: false,
  showOnboarding: false,
  showOnboardingV2: false,
  lastChangedFilter: '',
  shouldScroll: false,
  educationalMessage: '',
  guestFilterTooltip: false,
  shouldStoreCapacity: false,
  showTrustBuilderPopup: false,
  activeTabTrustBuilderPopup: 0,
  globalLoading: {
    heroSectionLoading: true,
    secondaryFilterLoading: true,
    dealListLoading: true,
    hintsBlockLoading: true,
  },
  showAirportPopup: false,
  fromWhereHompageActiveId: [],
  wizardCompleted: false,
  showGroupBookingModal: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppState: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setLastChangedFilter: (state, action) => {
      state.lastChangedFilter = action.payload;
    },
    setShouldScroll: (state, action) => {
      state.shouldScroll = action.payload;
    },
    setEducationalMessage: (state, action) => {
      state.educationalMessage = action.payload;
    },
    setShowTrustBuilderPopup: (state, action) => {
      state.showTrustBuilderPopup = action.payload;
    },
    setShowAirportPopup: (state, action) => {
      state.showAirportPopup = action.payload;
    },
    setActiveTabTrustBuilderPopup: (state, action) => {
      state.activeTabTrustBuilderPopup = action.payload;
    },
    setGlobalLoading: (state, action) => {
      state.globalLoading = action.payload;
    },
    setFromWhereHompageActiveId: (state, action) => {
      state.fromWhereHompageActiveId = action.payload;
    },
    setShowGroupBooking: (state, action) => {
      state.showGroupBookingModal = action.payload;
    },
  },
});

export const {
  setAppState,
  setLastChangedFilter,
  setShouldScroll,
  setEducationalMessage,
  setShowTrustBuilderPopup,
  setActiveTabTrustBuilderPopup,
  setGlobalLoading,
  setShowAirportPopup,
  setFromWhereHompage,
  setFromWhereHompageActiveId,
  setShowGroupBooking,
} = appSlice.actions;

export const filterSaveClick = createAction('filters/saveClick');
export const filterClearClick = createAction('filters/clearClick');

export const selectAppState = (state) => state.app;
export const selectGlobalLoading = (state) => state.app.globalLoading;
export const selectAirportPopup = (state) => state.app.showAirportPopup;
export const selectFromWhereHompageActiveId = (state) => state.app.fromWhereHompageActiveId;

export const selectIsAnyFilterOpened = createSelector(
  state => state.modals.mainFilter,
  state => state.modals.secondaryFilter,
  (mainFilter, secondaryFilter) => {
    return Object.values(mainFilter).some(Boolean) || Object.values(secondaryFilter).some(Boolean);
  }
)

export default appSlice.reducer;
